import React from 'react';

import { Stack } from '@good/ui/core';

import { BookingsRosterView } from './bookings-roster-view/bookings-roster-view';
import { useSearchParam } from 'utilities/react-hooks/use-search-param';
import { BookingsViewProvider } from './books-view-context/bookings-view-context';
import { BookingsViewToolbar } from './booking-view-toolbar/bookings-view-toolbar';
import { BookingsViewType } from './booking-view-toolbar/types';
import { BookingsTable } from './bookings-table/bookings-table';
import { BookingTabViewProvider } from './books-view-context/booking-tab-view-context';
import { BookingsQueryProvider } from './books-view-context/bookings-query-context';

type BookingsViewSwitchProps = {
  view: BookingsViewType;
};

export const BookingsViewSwitch = ({ view }: BookingsViewSwitchProps) => {
  switch (view) {
    case 'list':
      return <BookingsTable />;
    case 'calendar':
      return <BookingsRosterView />;
    default:
      return <BookingsTable />;
  }
};

export const BookingsViewVersion2 = () => {
  const [view, setView] = useSearchParam<BookingsViewType>('view', 'list');

  return (
    <BookingsQueryProvider>
      <BookingTabViewProvider>
        <BookingsViewProvider view={view}>
          <Stack gap={0}>
            <BookingsViewToolbar view={view} onChangeView={setView} />
            <BookingsViewSwitch view={view} />
          </Stack>
        </BookingsViewProvider>
      </BookingTabViewProvider>
    </BookingsQueryProvider>
  );
};
